const divModalFilterEquip = {
  cancel: 'CANCEL',
  ok: 'APPLY'
};

export default divModalFilterEquip;
